/* LEGAL-NOTICE
   © Copyright 2018 - Quid Informatica S.p.A. - All Rights Reserved
   https://quidinfo.it/qinetic/licence.html - "Quid Consumer Lending Platform"
   Deposito SIAE n. 012702 del 26 Luglio 2018
LEGAL-NOTICE */
import { QuotationDTO } from '@api/models/.';
import { QuotationDataModel } from '@models/.';
import {
  Component,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  EventEmitter
} from '@angular/core';
import { QuotationService } from '@services/quotation/quotation.service';
import { UiService } from '@services/ui/ui.service';

@Component({
  selector: 'app-quotation-preview',
  templateUrl: './quotation-preview.component.html',
  styleUrls: ['./quotation-preview.component.scss']
})
export class QuotationPreviewComponent implements OnChanges {
  /**
   * nome cliente
   */
  @Input() customerName: string;

  /**
   * dati quotation
   */
  @Input() quotation: QuotationDTO;

  /**
   * dati primari visualizzati nella card
   */
  @Input() primaryData: QuotationDataModel[];

  /**
   * flag per visualizzare il bottone modifica
   */
  @Input() editable: boolean;

  /**
   * lista di codici che indica il motivo per il quale il preventivo risulta aggiornato
   * rispetto a quanto richiesto dall'utente
   */
  @Input() updatedAfter: string[];

  /**
   * evento emesso sul click del pulsante di modifica
   */
  @Output() edit = new EventEmitter<void>();

  /**
   * dettagli
   */
  details: string;

  /**
   * dettagli per screen reader
   */
  ariaDetails: string;

  constructor(
    private uiService: UiService,
    private quotationService: QuotationService
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    if (!!changes.quotation || !!changes.primaryData) {
      this.updateDetails();
      this.mapData();
    }
  }

  onEdit(): void {
    this.edit.emit();
  }

  /**
   * apre modale di dettaglio
   */
  async openDetailsModal(): Promise<void> {
    const parts = [`lbl.quotation_details_message`];

    if (this.updatedAfter && this.updatedAfter.length > 0) {
      this.updatedAfter
        .map(code => `lbl.quotation_updated_after_${code}_message`)
        .forEach(label => parts.unshift(label));
    }

    const description = parts
      .map(part =>
        this.quotationService.getLabelWithQuotationData(part, this.quotation)
      )
      .join('<br><br>');

    this.uiService.showTooltipAsModal({
      title: 'lbl.quotation_details_title',
      description
    });
  }

  /**
   * aggiorna i dettagli
   */
  private updateDetails(): void {
    this.details = this.quotationService.getLabelWithQuotationData(
      'lbl.quotation_confirm_details_message',
      this.quotation
    );

    this.ariaDetails = this.quotationService.getLabelWithQuotationData(
      'aria.quotation_confirm_details_message',
      this.quotation
    );
  }

  /**
   * mappa i dati della quotation
   */
  private mapData(): void {
    this.mapPrimaryData();
  }

  /**
   * mappa i dati della quotation sulla lista di primary data
   */
  private mapPrimaryData(): void {
    this.primaryData.forEach(
      data => (data.value = this.getQuotationFieldValue(data.id))
    );
  }

  /**
   * ottiene il value del dato recuperandolo dalla quotation
   */
  private getQuotationFieldValue(fieldId): number {
    const value = this.quotation && this.quotation[fieldId];

    if (typeof value === 'number') {
      return value;
    } else {
      return 0;
    }
  }
}
